import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function NavBar() {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    return (
        <header
            data-testid="main-navbar"
            className={`fixed inset-x-0 top-0 z-40 transition-all duration-500 ${
                scrolled
                    ? "bg-ivory/80 backdrop-blur-xl border-b border-charcoal/5"
                    : "bg-transparent"
            }`}
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
                <Link
                    to="/"
                    data-testid="nav-logo"
                    className="group flex items-center gap-2.5"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                    <span className="relative inline-flex h-7 w-7 items-center justify-center rounded-full bg-charcoal text-ivory">
                        <span className="font-serif italic text-[13px]">V</span>
                    </span>
                    <span className="font-serif text-lg tracking-tight text-charcoal">
                        Vowze<span className="text-gold">.</span>
                    </span>
                </Link>
                <nav className="hidden items-center gap-10 md:flex">
                    <a data-testid="nav-link-how" href="#how" className="text-sm text-charcoal/75 transition hover:text-charcoal">
                        How it works
                    </a>
                    <a data-testid="nav-link-preview" href="#preview" className="text-sm text-charcoal/75 transition hover:text-charcoal">
                        Sample report
                    </a>
                    <a data-testid="nav-link-pricing" href="#pricing" className="text-sm text-charcoal/75 transition hover:text-charcoal">
                        Pricing
                    </a>
                </nav>
                <a
                    href="#pricing"
                    data-testid="nav-cta-start"
                    className="btn-gold !py-2.5 !px-5 text-[13px]"
                >
                    Create My Wedding Vision
                </a>
            </div>
        </header>
    );
}
